import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function AdminLogin() {
  const [Id, setId] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleAdminLogin = (e) => {
    e.preventDefault();

    if (Id === "ADMIN123" && password === "Strong@Pass123") {
      localStorage.setItem("adminToken", "valid");
      navigate("/admin/dashboard");
    } else {
      alert("Invalid admin credentials!");
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div style={{ padding: "30px", border: "1px solid #ccc", borderRadius: "10px", background: "white" }}>
        <h2 style={{ marginBottom: "20px", textAlign: "center" }}>Admin Login</h2>

        <form onSubmit={handleAdminLogin}>
          <input
            type="text"
            placeholder="Admin ID"
            value={Id}
            onChange={(e) => setId(e.target.value)}
            required
            style={{ display: "block", marginBottom: "10px", padding: "10px", width: "250px" }}
          />
          <input
            type="password"
            placeholder="Admin Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ display: "block", marginBottom: "10px", padding: "10px", width: "250px" }}
          />
          <button
            type="submit"
            style={{ padding: "10px", width: "250px", background: "#0d6efd", color: "white", border: "none", borderRadius: "5px" }}
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
